import { GET_IMAGES } from '../actions/index';

const INITIAL_STATE = {
  images: null,
  error: null
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_IMAGES:
      if (action.payload.status === 200) {
        return { ...state, images: action.payload.data };
      } else {
        if (action.payload.response) {
          if (action.payload.response.status === 400) {
            return { ...state, images: action.payload.response };
          } if (action.payload.response.status === 401) {
            return { ...state, images: action.payload.response };
          }
        } else {
          return { ...state, error: "No internet connection" }
        }
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_posts.js